import React, { ReactElement } from "react";
import { DownloadButtonComponent } from "./style";

export default function DownloadButton(): ReactElement {
    return (
        <DownloadButtonComponent href="https://drive.google.com/file/d/1Y-X_DQL49BDqQpJTmO5MIvY938W3vLeW/view" target="_blank" rel="noopener noreferrer">
            Download
        </DownloadButtonComponent>
    );
}